import { Col, Form, Input } from 'antd';
import type { IField } from '../data';
import styles from '../styles.less';

const { Item } = Form;

const Password: React.FC<IField> = (props) => {
    const { name, span = 8, label, rules, placeholder, disabled, hasFeedback = false, dependencies, xs, lg, marginBottom = 0, t } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item
                {...styling}
                label={t?.(label)}
                name={name}
                hasFeedback={hasFeedback}
                rules={[
                    ...(rules || []),
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!dependencies) return Promise.resolve();
                            const dependency: any = dependencies[0];
                            if (!dependencies || !value || getFieldValue(dependency) === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error(t?.('The two passwords that you entered do not match!')));
                        },
                    }),
                ]}
                dependencies={dependencies ?? []}
            >
                <Input.Password placeholder={t?.(placeholder)} className={styles.fullWidth} disabled={disabled} />
            </Item>
        </Col>
    );
};

export default Password;
